require("../assets/styles/about.css");

function About() {
  return (
    <div className="about-container">
      <div className="about-title">my story</div>
      <img
        className="shriti-portrait"
        src={require("../assets/images/shritiportrait.jpg")}
        alt="portrait"
      ></img>
      <div className="about-text">
        <p>
          Drawn to art from an early age, Shriti grew up in a family where
          creativity was valued but not seen as a career path.
        </p>
        <p>
          After qualifying and working as a dentist in London, the unexpected
          loss of her husband, Chris, changed everything. Left to raise three
          children on her own, Shriti was faced with a powerful reminder of
          life’s fragility and its urgency.
        </p>
        <p>
          Today, Shriti works as an artist, creating pieces that reflect the
          heart of her experiences. As a self-taught creative, she embraces a
          freedom that transcends traditional methods. Her work is inspired by
          the rich palette of nature, the atmosphere of the place, and the moods
          they stir. She’s drawn to the quiet rhythms of people and animals in
          motion, and to the subtle moments of daily life where emotion is
          expressed and evoked through small, meaningful gestures. At times
          abstract, her art is as much about feeling as it is about form. Thus,
          Shriti’s portfolio spans bold oil paintings with rich knife textures
          to fine, monochromatic studies in pen, ink, and watercolour.
        </p>
        <p>
          Commissions play a key role in her practice, pushing her into new
          territory and deepening her creative growth.
        </p>
        <p>
          In her garden studio, Shriti runs workshops for adults and young
          people alike. These small, intimate sessions often lead to surprising
          discoveries of untapped creativity. Alongside her art, she also
          practices craniosacral therapy, a meditative, grounding technique that
          enriches her process and perspective.
        </p>
      </div>
    </div>
  );
}

export default About;
